<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2022-09-10 20:17:16
 * @LastEditTime: 2022-11-20 14:28:51
 * @LastEditors: chenguobiao
-->
<template>
  <div class="broadcast-question" :style="{marginLeft: question.typeCode === 'ai' ? '-8.2rem' : '-5.5rem'}" @click="handlePlay" v-if="reportNumber <= 3">
    <img v-if="playing" src="@/render/assets/images/grading/icon_report_playing.gif" alt="" />
    <img v-else src="@/render/assets/images/grading/icon_report.png" alt="" />
    <p>播报题目{{['singel_selection', 'true_or_false', 'multi_selection'].includes(question.typeCode) ? '及选项' : ''}}</p>
    <!-- <audio src="https://nls-gateway-cn-shanghai.aliyuncs.com/stream/v1/tts?appkey=WsExOpNfU4N8U7KR&token=58d8e51aa731480ea1ec8cbc1a9ddc92&text=%E4%BD%A0%E5%A5%BD%E5%95%8A%EF%BC%81%EF%BC%81%EF%BC%81&format=wav&voice=siyue&sample_rate=16000" autoplay></audio> -->
  </div>
</template>
<script>
// import axios from 'axios'
import { QUESTION_TYPE_MAPPING_TITLE } from '@/config/const'
import { mapGetters } from 'vuex'
export default {
  props: {
    question: Object
  },
  data() {
    return {
      playing: false
    }
  },
  computed: {
    mergeProps() {
      return [this.question, this.voiceToken]
    },
    ...mapGetters('grading', ['voiceToken', 'reportNumber']),
  },
  mounted() {
    this.initBroadcast()
    this.$store.dispatch('grading/getVoiceToken').then(() => this.setSrc(this.question, this.voiceToken))
  },
  watch: {
    question: {
      deep: true,
      immediate: true,
      handler(question) {
        this.setSrc(question, this.voiceToken)
        this.$store.commit('grading/setReportNumber', 0)
      }
    },
  },
  methods: {
    initBroadcast() {
      let broadcast = document.getElementById('#broadcast')
      if (!broadcast) {
        broadcast = document.createElement('audio')
        broadcast.setAttribute('id', 'broadcast')
        document.body.appendChild(broadcast)
      }
      broadcast.addEventListener('play', () => {
        this.playing = true
      })
      broadcast.addEventListener('pause', () => {
        this.playing = false
      })
      this.$broadcast = broadcast
    },
    setSrc(question, voiceToken) {
      if (question && voiceToken && this.$broadcast) {
        this.$broadcast.src = `https://nls-gateway-cn-shanghai.aliyuncs.com/stream/v1/tts?appkey=WsExOpNfU4N8U7KR&token=${voiceToken}&text=${this.getText(question)}&format=wav&voice=siyue&sample_rate=16000`
      }
    },
    getText(question) {
      let text = `（${QUESTION_TYPE_MAPPING_TITLE[question.typeCode]}）${this.getPauseTimes()}${question.topic}${this.getPauseTimes()}（${question.score}分）${this.getPauseTimes()}`
      if (['singel_selection', 'true_or_false', 'multi_selection'].includes(question.typeCode)) {
        text += question.answerList.map(answer => `${answer.number.toUpperCase()}${this.getPauseTimes()}${answer.description}`).join(this.getPauseTimes())
      }
      return encodeURIComponent(text.replace(/\(\)|（）/g, '括号'))
    },
    getPauseTimes(number = 3) {
      return new Array(number).join('。')
    },
    handlePlay() {
      console.log('点击播报')
      if (this.playing) return
      this.$store.commit('grading/setReportNumber', this.reportNumber + 1)
      if (this.reportNumber > 3) {
        this.$message.error('播报过于频繁！')
        return
      }
      this.$broadcast.play()
    },
    handlePause() {
      this.$broadcast.pause()
    }
  },
}
</script>
<style lang="scss" scoped>
.broadcast-question {
  position: absolute;
  top: val(300);
  // left: val(125);
  left: 50%;
  margin-left: val(-550);
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  z-index: 9;
  img {
    margin-bottom: val(10);
    width: val(100);
  }
  p {
    font-size: val(20);
    color: #3e2c00;
    text-align: center;
  }
}
</style>
